import { requireAnySystemPermission } from '@juvare/contact-management/backend/features/permissions/shared';
import { AuthError } from '@juvare/platform-app/App';
import { ClassifierDef, defineClassifierEntity, transformClassifierColumns } from '@juvare/platform-sdk-react/backend/features/classifiers';
import { classifierColumns, ClassifierData } from '@juvare/platform-sdk-react/backend/features/classifiers/shared';
import { defineColumns, EntityColumns } from '@juvare/platform-shared/features/storage';

export const departmentEntityName = 'department';

export interface DepartmentData extends ClassifierData {
    description: string;
}

const departmentColumns = defineColumns({
    ...classifierColumns,
    description: {
        type: 'string',
    },
    search: {
        type: 'full-text-search-required',
        language: 'english',
    },
});

export type DepartmentColumns = EntityColumns<typeof departmentColumns>;

type DepartmentDef = ClassifierDef<DepartmentData, DepartmentColumns>;

export function defineDepartmentClassifier(): DepartmentDef {
    return defineClassifierEntity<DepartmentData, DepartmentColumns>({
        entity: {
            version: 1,
            columns: departmentColumns,
            onMigrate: (params) => params.oldData,
            onTransformColumns: (context, params) => ({
                ...transformClassifierColumns(params),
                description: params.data.description,
                search: [params.data.name, params.data.status].join(' '),
            }),
            onAnonymousAuthGet: (appState, response) => response,
            onAnonymousAuthList: (appState, response) => response,
            onAuthPost: (appState, userState) => {
                if (!requireAnySystemPermission(userState, 'manage-client-classifiers')) {
                    throw new AuthError('Unauthorized');
                }
            },
        },
    });
}
